export const getLaunchableIdFromSearch = (search: string): string | null =>
  new URLSearchParams(search).get("launchableID");

export interface LaunchableDeployOverrides {
  instanceType?: string;
  cloudCredentialId?: string;
  diskStorage?: string;
  location?: string | null;
}

export const getLaunchableDeployOverrides = (
  search: string,
): LaunchableDeployOverrides => {
  const params = new URLSearchParams(search);
  const location = params.has("location")
    ? params.get("location") === "any"
      ? null
      : (params.get("location") ?? undefined)
    : undefined;

  return {
    instanceType: params.get("instance") ?? undefined,
    cloudCredentialId:
      params.get("cloudCredId") ?? params.get("cloudCredID") ?? undefined,
    diskStorage: params.get("diskStorage") ?? undefined,
    location,
  };
};

export const setLaunchableDeployOverrides = (
  search: string,
  overrides: LaunchableDeployOverrides,
): string => {
  const params = new URLSearchParams(search);

  if (overrides.instanceType !== undefined) {
    params.set("instance", overrides.instanceType);
  }
  if (overrides.cloudCredentialId !== undefined) {
    params.set("cloudCredId", overrides.cloudCredentialId);
    params.delete("cloudCredID");
  }
  if (overrides.diskStorage !== undefined) {
    params.set("diskStorage", overrides.diskStorage);
  }
  if (overrides.location !== undefined) {
    params.set("location", overrides.location ?? "any");
  }

  return params.toString();
};
